import React, { Component } from 'react';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

class ShowPasswordButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
    };
  }

  handleToggle = () => {
    const { onToggle } = this.props;
    this.setState(
      prevState => ({ showPassword: !prevState.showPassword }),
      () => {
        if (onToggle) {
          onToggle(this.state.showPassword);
        }
      }
    );
  };

  render() {
    const { showPassword } = this.state;

    return (
      <InputAdornment position="end">
        <IconButton onClick={this.handleToggle}>
          {showPassword ? <VisibilityOff /> : <Visibility />}
        </IconButton>
      </InputAdornment>
    );
  }
}

export default ShowPasswordButton;
